import { render, staticRenderFns } from "./TariffExceptionListPage.vue?vue&type=template&id=3ca64f33&"
import script from "./TariffExceptionListPage.vue?vue&type=script&lang=ts&"
export * from "./TariffExceptionListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports